import { Box, ContentBlock, Heading, Stack, Text } from 'braid-design-system';
import React, { Fragment } from 'react';

import Header from 'src/components/Header/Header';

import Section from './components/Section/Section';
import Title from './components/Title/Title';

const PreferencesSubmitted = () => (
  <Fragment>
    <Header title="Customise your recommendations" />
    <Box paddingBottom="xlarge" width="full">
      <Title />
    </Box>
    <ContentBlock>
      <Section>
        <Stack space="medium">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            paddingBottom="medium"
          >
            <Heading level="2">Thank you!</Heading>
          </Box>
          <Box paddingBottom="medium">
            <Text>
              Your business preferences have been updated. When we find newly
              listed businesses that match your preferences, we&apos;ll send
              them your way, straight to your inbox.
            </Text>
          </Box>
          <Box>
            <Heading level="4">How to edit/change your preferences:</Heading>
          </Box>
          <Box paddingBottom="xlarge">
            <Text>
              You can make changes to your preferences at any time via your
              profile when logged in, or via the recommendations email. For now,
              sit back while we look for matching businesses.
            </Text>
          </Box>
        </Stack>
      </Section>
    </ContentBlock>
  </Fragment>
);

export default PreferencesSubmitted;
